/** Chat copy in English and Turkish: ?lang=tr|en, else the browser's language. */
const EN = {
  title: 'Live chat',
  placeholder: 'Say something…',
  send: 'Send',
  join: 'Join chat',
  nickPrompt: 'Pick a nickname to chat',
  nickPlaceholder: 'Nickname',
  chattingAs: 'Chatting as',
  change: 'change',
  host: 'Host',
  moderator: 'Mod',
  pinned: 'Pinned',
  newMessages: 'New messages',
  empty: 'No messages yet. Say hello!',
  slowMode: (s: number) => `Slow mode: one message every ${s} s`,
  slowModeAuto: (s: number) => `Busy chat: one message every ${s} s`,
  wait: (s: number) => `Wait ${s} s`,
  paused: 'Chat is paused',
  closedPending: 'Chat opens when the stream starts',
  closed: 'Chat is closed',
  readOnly: 'Chat has ended',
  busy: 'Chat is busy, try again in a moment',
  tooMany: 'Too many messages from your network. Wait a minute.',
  noLinks: 'Links aren’t allowed in chat',
  failed: 'Couldn’t send. Try again.',
  offline: 'Reconnecting…',
  react: (name: string) => `React with ${name}`,
  close: 'Close chat',
  open: 'Chat',
  announce: (n: number) => `${n} new messages`,
  reactions: { heart: 'heart', clap: 'applause', laugh: 'laughter', fire: 'fire', party: 'party', wow: 'wow' } as Record<string, string>,
  moderating: 'Moderating as',
  slow: 'Slow',
  off: 'Off',
  pause: 'Pause',
  resume: 'Resume',
  pin: 'Pin',
  unpin: 'Unpin',
  del: 'Delete',
  ban: 'Ban',
  confirmBan: (n: string) => `Ban ${n}? Their messages will only show to themselves.`,
  modLinkInvalid: 'This moderator link was already used or has expired. Ask the stream owner for a new one.',
  modWelcome: (n: string) => `You moderate this chat as ${n}.`,
  modFailed: 'That did not work. Try again.',
};
type Copy = typeof EN;

const TR: Copy = {
  title: 'Canlı sohbet',
  placeholder: 'Bir şey yaz…',
  send: 'Gönder',
  join: 'Sohbete katıl',
  nickPrompt: 'Sohbet için bir takma ad seç',
  nickPlaceholder: 'Takma ad',
  chattingAs: 'Takma adın:',
  change: 'değiştir',
  host: 'Yayıncı',
  moderator: 'Mod',
  pinned: 'Sabitlendi',
  newMessages: 'Yeni mesajlar',
  empty: 'Henüz mesaj yok. Merhaba de!',
  slowMode: (s) => `Yavaş mod: ${s} sn'de bir mesaj`,
  slowModeAuto: (s) => `Sohbet yoğun: ${s} sn'de bir mesaj`,
  wait: (s) => `${s} sn bekle`,
  paused: 'Sohbet duraklatıldı',
  closedPending: 'Sohbet yayın başlayınca açılacak',
  closed: 'Sohbet kapalı',
  readOnly: 'Sohbet sona erdi',
  busy: 'Sohbet çok yoğun, birazdan tekrar dene',
  tooMany: 'Ağından çok fazla mesaj geldi. Bir dakika bekle.',
  noLinks: 'Sohbette bağlantı paylaşılamaz',
  failed: 'Gönderilemedi. Tekrar dene.',
  offline: 'Yeniden bağlanıyor…',
  react: (name) => `${name} ile tepki ver`,
  close: 'Sohbeti kapat',
  open: 'Sohbet',
  announce: (n) => `${n} yeni mesaj`,
  reactions: { heart: 'kalp', clap: 'alkış', laugh: 'kahkaha', fire: 'ateş', party: 'kutlama', wow: 'şaşkınlık' },
  moderating: 'Moderatör:',
  slow: 'Yavaş',
  off: 'Kapalı',
  pause: 'Duraklat',
  resume: 'Devam',
  pin: 'Sabitle',
  unpin: 'Kaldır',
  del: 'Sil',
  ban: 'Engelle',
  confirmBan: (n) => `${n} engellensin mi? Mesajlarını yalnızca kendisi görür.`,
  modLinkInvalid: 'Bu moderatör bağlantısı kullanılmış ya da süresi dolmuş. Yayın sahibinden yenisini iste.',
  modWelcome: (n) => `Bu sohbeti ${n} olarak yönetiyorsun.`,
  modFailed: 'Olmadı. Tekrar dene.',
};

export function copyFor(lang: string | null): Copy {
  const l = (lang || navigator.language || 'en').toLowerCase();
  return l.startsWith('tr') ? TR : EN;
}
export type { Copy };
